import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
    Progress,
    message,
} from 'antd'
import { firestore, firStorage } from '../../../service/firebase'
import './Sight.scss'

const { TextArea } = Input


export default class Sight extends React.Component {
    
    columns = [
        { title: "Logo", dataIndex: 'logo', key: 'logo', render: logo => {
            console.log("LOGO", logo)
            if(!logo || logo.length === 0) {
                return <div className="no-logo">NO LOGO!</div>
            } else {
                return <img src={logo} style={{maxWidth: 50, maxHeight: 50}} alt="IMG-LOGO" />
            }
        } },
        { title: "Title", dataIndex: 'title', key: 'title' },
        { title: "Address", dataIndex: 'address', key: 'address' },
        { title: "Link", dataIndex: 'url', key: 'url', render: url => {
            return <a href={url}>{url}</a>
        } },
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        showModal: false,
        showBannerEdit: false,
        uploadState: 0,
        uploadBanner: 0,
        downloadURL: '',
        bannerProgress: 0,
    }

    selEditItem = null

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('Sight')
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    data['bannerSelected'] = 0
                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth())
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            id: '',
            logo: null,
            title: '',
            description: '',
            address: '',
            url: '',
            facebook: null,
            phone: null,
            banner: null,
            showModal: true,
            uploadState: 0,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        let state = this.state

        let newState = Object.assign(state, item, {
            showModal: true,
            uploadState: 2,
        })

        this.selEditItem = item

        console.log(newState)
        this.setState(newState)
    }

    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Sight').doc(item.id).delete()
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Sight').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Sight').doc(id)
        }

        let object = {
            id,
            title: state.title ? state.title : '',
            description: state.description ? state.description : '',
            address: state.address ? state.address : '',
            banner: state.banner ? state.banner : [],
            logo: state.logo ? state.logo : '',
            url: state.url ? this.link(state.url) : '',
            facebook: state.facebook ? this.link(state.facebook) : '',
            phone: state.phone ? state.phone : '',
        }

        console.log(object)

        ref.set(object)
        this.setState({showModal: false})
    }

    handleBannerOK() {
        // Update Banners
        this.setState({showBannerEdit: false})
    }

    link(text) {
        if(text.substring(0, 4) === 'http') {
            return text
        } else {
            return 'http://' + text
        }
    }

    handleClose() {
        this.setState({showModal: false})
    }


    /*-----------------Upload Image-------------------*/

    handleUpload(input, isLogo) {
        this.isLogo = isLogo
        input.click()
    }

    uploadFile(file, path) {
        if(this.state.uploadState === 1) {
            return
        }

        this.setState({uploadState: 1})

        var uploadTask = firStorage.ref().child(path).put(file)
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.setState({uploadProgress: progress})
            console.log('Upload is ' + progress + '% done')
        }, (error) => {
            this.setState({uploadState: 0})
            message.error("Failed on uploading image! Try again please!")
            console.log("Upload Error", error)
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL)
                this.setState({
                    uploadState: 2,
                    logo: downloadURL
                })
            })
        })
    }


    /*-----------------Process Banner Image-------------------*/

    onChangeFile(evt) {
        let orgName = evt.target.files[0].name
        let key = Date.now()
        let fileName = key + "." + orgName.substring(orgName.length - 3)
        let path = '/images/' + fileName

        if(this.isLogo) {
            this.uploadFile(evt.target.files[0], path)
        } else {
            this.uploadBanner(evt.target.files[0], path)
        }
    }
    
    uploadBanner(file, path) {
        if(this.state.uploadBanner === 1) {
            return
        }

        this.setState({uploadBanner: 1})

        var uploadTask = firStorage.ref().child(path).put(file)
        uploadTask.on('state_changed', (snapshot) => {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.setState({bannerProgress: progress})
            console.log('Upload is ' + progress + '% done')
        }, (error) => {
            this.setState({uploadBanner: 0})
            message.error("Failed on uploading image! Try again please!")
        }, () => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL, this.selEditItem)
                if(!this.selEditItem.banner || this.selEditItem.banner.length === 0) {
                    this.selEditItem.banner = [downloadURL]
                } else {
                    this.selEditItem.banner.push(downloadURL)
                }

                this.setState({
                    uploadBanner: 2,
                })

                this.updateItem(this.selEditItem)
            })
        })
    }

    handleBannerSelected(row, index) {
        row['bannerSelected'] = index
        this.forceUpdate()
    }

    handleDeleteBanner(row) {
        let index = row['bannerSelected']
        row.banner.splice(index, 1)
        if(row.banner.length < row['bannerSelected'] - 1) {
            row['bannerSelected'] = row.banner.length - 1
        }

        this.updateItem(row)
    }

    updateItem(row) {
        let ref = firestore.collection('Sight').doc(row.id)
        ref.update(row)
    }

    handleEditBanner(row) {
        this.selEditItem = row
        console.log("Handle banner", this.selEditItem)
        this.setState({showBannerEdit: true})
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/

    renderCellDetail(row) {
        console.log(row)
        let selected = row['bannerSelected']

        return(
            <Row className="cell">
                <div className="img-left">
                    <div className="img">
                        <img src={row.logo} alt="IMG-LOGO" />
                    </div>
                    <div className="banner">
                        <div className="title">
                            Banners
                            <Button style={{marginLeft: 20}} type="primary" icon="edit" onClick={() => this.handleEditBanner(row)}>Edit</Button>
                        </div>

                        <div className="img-viewer">
                            <div className="img-view">
                                { row.banner[selected] ? <img src={row.banner[selected]} alt="MAIN-VIEW" /> : 'NO IMAGE' }
                            </div>
                            <div className="img-list">
                            {
                                row.banner && row.banner.map((banner, index) => {
                                    return (
                                        <img className={index === row.bannerSelected ? 'selected' : ''} 
                                            key={index} src={banner} alt="BANNER-ITEM" 
                                            onClick={() => this.handleBannerSelected(row, index)} />
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="content-row"><div className="caption"><b>Title :</b></div>{row.title}</div>
                    <div className="content-row"><div className="caption"><b>Address :</b></div> {row.address ? row.address : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Link :</b></div> {row.url ? <a href={row.url}>{row.url}</a> : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Facebook :</b></div> {row.facebook ? <a href={row.facebook}>{row.facebook}</a> : '-'}</div>
                    <div className="content-row"><div className="caption"><b>Phone :</b></div> {row.phone ? row.phone : '-'}</div>
                    <div style={{margin: '20px 5px 5px 5px', display: 'flex'}}><div className="caption"><b>Description :</b></div></div>
                    <div style={{margin: 5, marginLeft: 100, maxHeight: 400, overflowY: 'auto'}}>{row.description}</div>
                </div>
            </Row>
        )
    }

    
    render() {

        return (
            <div className="sight">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Sight & Attractions</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    expandedRowRender={record => this.renderCellDetail(record)} 
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                
                <Modal
                    title={this.eventEdit ? 'Edit Sight & Attractions' : "Add Sight & Attractions"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleClose()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Address</div>
                        <Input value={this.state.address} onChange={evt => this.handleChange('address', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Link</div>
                        <Input value={this.state.url} onChange={evt => this.handleChange('url', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Facebook</div>
                        <Input value={this.state.facebook} onChange={evt => this.handleChange('facebook', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Phone</div>
                        <Input value={this.state.phone} onChange={evt => this.handleChange('phone', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Description</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} value={this.state.description} onChange={evt => this.handleChange('description', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Logo Image</div>
                        <div style={{cursor: 'pointer'}} onClick={() => this.handleUpload(this.logoInput, true)}>
                        {
                            this.state.uploadState === 0 ?
                                <div className="logo-placeholder">Logo</div> :
                            this.state.uploadState === 1 ?
                                <div style={{margin: 20}}>
                                    <Progress type="circle" percent={this.state.uploadProgress ? Number(this.state.uploadProgress.toFixed(2)) : 0} />
                                </div> :
                                <div className="logo-img">
                                    <img src={this.state.logo} alt="IMG-LOGO" />
                                </div>
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.logoInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

                <Modal
                    className="banner-edit-dlg"
                    title='Edit Banner Images'
                    visible={this.state.showBannerEdit}
                    okText="Add Banner"
                    onOk={() => this.handleUpload(this.bannerInput)}
                    onCancel={() => this.setState({showBannerEdit: false})}>

                    <Row className="input-row">
                        <div className="input-label">
                            Selected Image 
                            {this.state.uploadBanner === 1 && ' (Uploading..' + this.state.bannerProgress.toFixed(2) + '%)'}
                        </div>
                        <div style={{cursor: 'pointer', position: 'relative'}}>
                            <div className="btn-remove">
                                <Button ghost type="danger" icon="delete" onClick={() => this.handleDeleteBanner(this.selEditItem)}></Button>
                            </div>
                            <div className="logo-img">
                                { 
                                    this.selEditItem && this.selEditItem.banner[this.selEditItem['bannerSelected']] ?
                                        <img src={this.selEditItem.banner[this.selEditItem['bannerSelected']]} alt="IMG-LOGO" /> :
                                        'NO IMAGE'
                                }
                            </div>
                        </div>

                        <div className="banner-list">
                        {
                            this.selEditItem && this.selEditItem.banner.map((banner, index) => {
                                let marginRight = 0
                                if(index === this.selEditItem.banner.length - 1) {
                                    marginRight = 10
                                }

                                return (
                                    <div key={index}>
                                        <img className={index === this.selEditItem.bannerSelected ? 'selected' : ''} 
                                            style={{marginRight: marginRight}}
                                            src={banner} alt="BANNER-ITEM" 
                                            onClick={() => this.handleBannerSelected(this.selEditItem, index)} />
                                    </div>
                                )
                            })
                        }
                        </div>
                    
                        <input type="file" className="file-input"
                            ref={input => this.bannerInput = input}
                            onChange={evt => this.onChangeFile(evt)}
                            accept="image/x-png,image/gif,image/jpeg" />

                    </Row>

                </Modal>

            </div>
        )
    }
}
